import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {emptyChat, emptyChatAttachment, IChat, IChatAttachment, IChatMessage} from "@retail-data-factory/rdf-angular-types-api";
import {mockChatList} from "./mock-chat";
import {v4 as uuidv4} from 'uuid';
import {emptyServiceResponse, IServiceResponse} from "../../../../services/external-api/response-interfaces";

@Injectable({
  providedIn: 'root'
})
export class ApiChatService {

  constructor() {
  }

  /**
   * Получить список чатов
   */
  getChatList(): Observable<Array<IChat>> {
    return of(mockChatList);
  }

  /**
   * Получить чат по ID
   * @param chatId
   */
  getChat(chatId: string): Observable<IChat> {
    const chat: IChat = mockChatList.find(t => t.chatId === chatId);
    if (chat) {
      return of(chat);
    } else {
      return of({...emptyChat});
    }
  }

  getAttachment(attachId: string): Observable<IChatAttachment> {
    return of({...emptyChatAttachment});
  }

  /**
   * Добавить сообщение в чат
   * @param chatId
   * @param message
   */
  postNewMessage(chatId: string, message: IChatMessage): Observable<IServiceResponse> {
    const chat: IChat = mockChatList.find(t => t.chatId === chatId);
    if (chat) {
      message.messageId = uuidv4();
      chat.messages.push(message);
    }
    return of({...emptyServiceResponse});
  }

  /**
   * Создать новый чат, при этом проверяется состав участников. Если он совпадает с уже существующим чатом, то он не будет создан
   * @param newChat
   */
  createChat(newChat: IChat): Observable<IChat> {
    const chat = mockChatList.find(t => {
      let founded = true;
      let i = 0;
      t.members.forEach(member => {
        const newMember = newChat.members.find(x => x.user.id === member.user.id);
        if (!newMember) {
          founded = false;
          i = 0;
        } else {
          i++
        }
      });
      if (newChat.members.length === i) {
        return true
      } else {
        return false
      }

    });
    if (!chat) {
      newChat.chatId = uuidv4();
      mockChatList.push(newChat);
      return of(newChat);
    } else {
      return of(chat);
    }
  }
}
